import { Controller } from "@hotwired/stimulus";
import { normalizeText, smartMatch } from "../../utils/smart_search";

/**
 * Roles Manager Controller
 * Manages the roles interface, including modal interactions and permission toggles
 */
export default class extends Controller {
  static targets = ["modal", "closeButton", "openButton", "permissionCheckbox", "searchInput", "rolesList", "roleItem", "noResults"];

  connect() {
    console.log("Roles manager controller connected");
  }

  // Filter roles based on search input
  filter() {
    const searchTerm = normalizeText(this.searchInputTarget.value);
    let visibleCount = 0;

    this.roleItemTargets.forEach((item) => {
      const roleName = item.dataset.roleName || "";
      const matches = smartMatch(roleName, searchTerm);

      if (matches) {
        item.classList.remove("hidden");
        visibleCount++;
      } else {
        item.classList.add("hidden");
      }
    });

    // Show/hide no results message
    if (this.hasNoResultsTarget) {
      if (visibleCount === 0 && searchTerm !== "") {
        this.noResultsTarget.classList.remove("hidden");
      } else {
        this.noResultsTarget.classList.add("hidden");
      }
    }
  }

  // Open the modal for adding a new role
  openModal(event) {
    event.preventDefault();
    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }

  // Close the modal
  closeModal(event) {
    event.preventDefault();
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  // Toggle all permissions in a row
  toggleRowPermissions(event) {
    const row = event.currentTarget.closest("tr");
    const checkboxes = row.querySelectorAll("input[type='checkbox']");

    checkboxes.forEach((checkbox) => {
      checkbox.checked = event.currentTarget.checked;
    });
  }

  // Toggle all permissions in a column
  toggleColumnPermissions(event) {
    const columnIndex = Array.from(
      event.currentTarget.closest("th").parentNode.children
    ).indexOf(event.currentTarget.closest("th"));
    const table = event.currentTarget.closest("table");
    const rows = table.querySelectorAll("tbody tr");

    rows.forEach((row) => {
      const checkbox = row.querySelectorAll("input[type='checkbox']")[
        columnIndex - 1
      ]; // -1 because first column is the resource name
      if (checkbox) {
        checkbox.checked = event.currentTarget.checked;
      }
    });
  }

  // Helper to select all checkboxes
  selectAll(event) {
    event.preventDefault();
    this.permissionCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  // Helper to deselect all checkboxes
  deselectAll(event) {
    event.preventDefault();
    this.permissionCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
